import { render, staticRenderFns } from "./PwaUpdatedNotification.vue?vue&type=template&id=5ea574e4&scoped=true"
import script from "./PwaUpdatedNotification.vue?vue&type=script&lang=js"
export * from "./PwaUpdatedNotification.vue?vue&type=script&lang=js"
import style0 from "./PwaUpdatedNotification.vue?vue&type=style&index=0&id=5ea574e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea574e4",
  null
  
)

export default component.exports